<template>
  <div class="app">
    <!-- <Scale_Box> -->
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <!-- </Scale_Box> -->
  </div>
</template>
<script>
// import Scale_Box from "./components/SacleBox/Index";
export default {
  name: "ScaleBox",
  components: {
    // Scale_Box,
  },
};
</script>

<style  scoped>
.app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue